/**
 * Showroom Reception API Service
 */

import { apiClient } from '../client';
import type {
  ApiResponse,
  ShowroomImportRequest,
  ShowroomOcrResponse,
  ShowroomConfirmRequest,
  ShowroomConfirmResult,
  ShowroomRecordListItem,
  ShowroomRecordDetail,
} from '../../types';

const API_PREFIX = '/api/saiens/showroom';

/**
 * OCR scan showroom reception form image (does not write to DB)
 */
export async function importShowroom(
  data: ShowroomImportRequest
): Promise<ApiResponse<ShowroomOcrResponse>> {
  const response = await apiClient.post<ApiResponse<ShowroomOcrResponse>>(
    `${API_PREFIX}/import`,
    data
  );
  return response.data;
}

/**
 * Confirm OCR result and write to DB
 */
export async function confirmShowroom(
  data: ShowroomConfirmRequest
): Promise<ApiResponse<ShowroomConfirmResult>> {
  const response = await apiClient.post<ApiResponse<ShowroomConfirmResult>>(
    `${API_PREFIX}/confirm`,
    data
  );
  return response.data;
}

/**
 * Get recent showroom reception records
 */
export async function getShowroomRecords(
  limit?: number
): Promise<ApiResponse<ShowroomRecordListItem[]>> {
  const response = await apiClient.get<ApiResponse<ShowroomRecordListItem[]>>(
    `${API_PREFIX}/records`,
    { params: { limit } }
  );
  return response.data;
}

/**
 * Get single showroom reception record detail
 */
export async function getShowroomRecord(
  id: number
): Promise<ApiResponse<ShowroomRecordDetail>> {
  const response = await apiClient.get<ApiResponse<ShowroomRecordDetail>>(
    `${API_PREFIX}/${id}`
  );
  return response.data;
}
